'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var addStep1SelectReceiverFormComponent = exports.addStep1SelectReceiverFormComponent = {
    template: require('./add-step1-select-receiver-form.html'),
    controllerAs: 'vm',
    bindings: {
        receiver: '<',
        selectReceiver: '&',
        cancel: '&'
    },
    controller: function addStep1SelectReceiverFormController() {
        'ngInject';

        var vm = this;

        vm.orderTypeId;
        vm.licenseNumber;
        vm.customerNumber;
        vm.error;
        vm.errorNotFound;

        vm.$onInit = init;
        vm.submitStep1Form = submitStep1Form;
        vm.onCancel = onCancel;

        function init() {
            resetStep1Form();
        }

        function resetStep1Form() {
            vm.orderTypeId = 1; // 'PA', Pakje apotheek
            vm.licenseNumber = vm.receiver ? vm.receiver.licenseNumber : null;
            vm.customerNumber = vm.receiver ? vm.receiver.customerNumber : null;
            vm.error = null;
            vm.errorNotFound = false;
        }

        function submitStep1Form() {
            if (!vm.licenseNumber || !vm.customerNumber) {
                vm.error = 'Gelieve vergunningsnummer en klantnummer in te geven.';
                vm.errorNotFound = false;
                return;
            } else if (isNaN(vm.licenseNumber) || isNaN(vm.customerNumber)) {
                vm.errorNotFound = true;
                vm.error = null;
            } else {
                vm.error = null;
                vm.errorNotFound = false;
                var selectedReceiver = void 0;

                selectedReceiver = {
                    orderTypeId: vm.orderTypeId,
                    licenseNumber: vm.licenseNumber,
                    customerNumber: vm.customerNumber,
                    businessUnitCode: null,
                    name: 'Tijskens Marc BVBA',
                    streetName: "Gasstraat",
                    houseNumber: "105",
                    boxNumber: null,
                    postalCode: "2060",
                    cityName: "Antwerpen",
                    id: 50
                };

                vm.selectReceiver({ $event: selectedReceiver });
            }
        }

        function onCancel() {
            vm.cancel();
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./features/account/my-packages/components/add-step1-select-receiver-form.js
// module id = 849
// module chunks = 0